import React from 'react';
import { motion } from 'framer-motion';

const Button = ({ children, variant = 'primary', className = '', ...props }) => {
    const baseStyles = "px-6 py-3 rounded-md font-semibold transition-all duration-300 flex items-center justify-center";

    const variants = {
        primary: "bg-gold-500 text-slate-900 hover:bg-gold-600 hover:shadow-lg",
        secondary: "bg-slate-850 text-white border border-slate-700 hover:bg-slate-800 hover:border-gold-500",
        outline: "bg-transparent text-slate-900 border-2 border-slate-900 hover:bg-slate-900 hover:text-white"
    };

    return (
        <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className={`${baseStyles} ${variants[variant]} ${className}`}
            {...props}
        >
            {children}
        </motion.button>
    );
};

export default Button;
